// extracted by mini-css-extract-plugin
export default {"component":"eXu_Q2","background-opacity":"Hx30Hr"};